

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { DeductionsSetup } from "../../components/DeductionsSetup/DeductionsSetup";


export const DeductionsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Deductions Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Deductions", navigateTo: "/company/deductions/list" },
        { text: "Create Deductions", navigateTo: "/company/deductions/setup" }
      ]}
      mainContents={<DeductionsSetup />}
    />
  );
};
